



























































































































































import { Observer } from 'mobx-vue'
import { Component, Provide, Vue } from 'vue-property-decorator'
import { FarmAdminViewModel } from '@/modules/admin/viewmodels/farm-admin-viewmodel'
import { walletStore } from '@/stores/wallet-store'
import { FarmTypes, LockPeriods } from '@/constants'

@Observer
@Component({
  components: {
    ConnectButton: () => import('@/components/ConnectButton.vue'),
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue')
  }
})
export default class extends Vue {
  @Provide() vm = new FarmAdminViewModel()
  walletStore = walletStore
  lockPeriods = LockPeriods
  farmTypes = FarmTypes

  headers = [
    {
      text: '-',
      value: 'index',
      sortable: false
    },
    {
      text: 'Farmer',
      value: 'address',
      sortable: false
    },
    {
      text: 'Staked LP',
      value: 'amount',
      sortable: false
    }
  ]

  goToBsc(address) {
    window.open('https://bscscan.com/address/' + address, '_blank')
  }
}
